export class BaseAudit {
  'createdAt'?: Date
  'updatedAt'?: Date
  'createdBy'?: string
  'updatedBy'?: string
}
